import { render, staticRenderFns } from "./IncomeProof.vue?vue&type=template&id=19dc9f71&scoped=true&"
import script from "./IncomeProof.vue?vue&type=script&lang=js&"
export * from "./IncomeProof.vue?vue&type=script&lang=js&"
import style0 from "./IncomeProof.vue?vue&type=style&index=0&id=19dc9f71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc9f71",
  null
  
)

export default component.exports